import httpClient from './httpClient';

const replacementService = {
    getRequests() {
        return httpClient.get('/api/adv/replacement-requests');
    },
    createRequest(id, data) {
        return httpClient.post(`/api/adv/replacement-request/${id}/application`, data);
    },
    deleteRequest(id, data) {
        return httpClient.delete(`/api/adv/replacement-request/${id}/application`, data);
    },
}

export default replacementService;